"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var format_1 = __importDefault(require("date-fns/format"));

var is_today_1 = __importDefault(require("date-fns/is_today"));

var is_yesterday_1 = __importDefault(require("date-fns/is_yesterday"));

exports.formatDate = function (date) {
  if (is_today_1["default"](date)) {
    return 'Dnes';
  }

  if (is_yesterday_1["default"](date)) {
    return 'Včera';
  }

  return format_1["default"](date, 'D.M.YYYY');
};

exports.getArticleDate = function (article) {
  return article.modified ? article.modified : article.date;
};

exports.getArticleMeta = function (article) {
  if (article.author && typeof article.author.name === 'string') {
    return exports.formatDate(exports.getArticleDate(article)) + " | " + article.author.name.toLocaleUpperCase();
  }

  return exports.formatDate(exports.getArticleDate(article));
};

exports.WIDGET_LINK_TYPE = {
  ARTICLE_DETAIL: 'article_detail',
  ARTICLE_FILTER: 'article_filter',
  SECTION_DETAIL: 'section_detail'
};

exports.getArticleUrl = function (article) {
  if (!article) {
    throw Error('Not article specified');
  }

  if (article.redirect) {
    return article.redirect;
  }

  if (article.url) {
    return "/" + article.url;
  }

  return "/article/" + article._id;
};